import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsInstallment({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M14.55 7.22h-.81a4.46 4.46 0 00-1.04-1.46l.52-2.1h-.89c-.81 0-1.54.38-2.03.96-.2-.03-.41-.06-.63-.06H6.1A4.45 4.45 0 001.75 8.1H.55a.67.67 0 01-.65-.8.68.68 0 01.68-.53h.03c.1 0 .17-.08.17-.17v-.55c0-.1-.08-.17-.17-.17-.8 0-1.5.57-1.6 1.35C-1.1 8.19-.37 9 .55 9h1.12c0 1.45.7 2.72 1.77 3.54v2.24c0 .24.2.44.45.44h1.78c.24 0 .44-.2.44-.44v-1.34h3.56v1.34c0 .24.2.44.44.44h1.78c.24 0 .44-.2.44-.44v-2.24c.33-.25.62-.54.87-.87h1.35c.25 0 .45-.2.45-.45V7.67c0-.25-.2-.45-.45-.45zM11 9a.45.45 0 01-.45-.44c0-.25.2-.45.45-.45A.446.446 0 0111 9zM6.1 3.67h3.56c.15 0 .3 0 .44.02v-.02a2.67 2.67 0 00-5.33 0l.01.17c.43-.1.86-.17 1.32-.17z" />
    </svg>
  );
}

SvgSettingsInstallment.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsInstallment.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsInstallment svgRef={ref} {...props} />
));
export default ForwardRef;
